module.exports = __webpack_public_path__ + "static/img/code.ea0aa480.png";